module.exports = __webpack_public_path__ + "img/sumary_grid.8c9b8dfd.svg";